export default __webpack_public_path__ + "static/media/ppc.205bb20b.jpg";